import React, { Component } from 'react'
import { Project } from '../../schema/types.d'

interface ProjectAttributeRowProps {
  title: string
  value: string
}

class ProjectAttributeRow extends Component<ProjectAttributeRowProps> {
  render() {
    const { title, value } = this.props
    return (
      <li className="lh-copy pa1 ph0-l">
        <div className="dt dt--fixed w-100">
          <div className="dtc">
            <span className="project-info-title">{title}: </span>
          </div>
          <div className="dtc pl3">
            <span className="project-info-value">{value}</span>
          </div>
        </div>
      </li>
    )
  }
}

interface InfoBoxProps {
  title: string
  info: string[][]
}

class InfoBox extends Component<InfoBoxProps> {
  render() {
    return (
      <article className="rectangle-14">
        <div className="project-detail-heading">{this.props.title}</div>
        <div className="dt">
          <div className="dtc v-mid">
            <ul className="list pl0 mt0 measure center">
              {this.props.info.map((infoEntry, index) => (
                <ProjectAttributeRow
                  key={index}
                  title={infoEntry[0]}
                  value={infoEntry[1]}
                />
              ))}
            </ul>
          </div>
        </div>
      </article>
    )
  }
}
interface ProjectDetailProps {
  project: Project.Project
}
class ProjectDetail extends Component<ProjectDetailProps> {
  render() {
    const project = this.props.project
    const location = project.location
    const basicInfo: string[][] = [
      ['Project Client', project.client],
      [
        'Project Location',
        location.city +
          ', ' +
          location.state +
          ', ' +
          location.country +
          ' ' +
          location.zip
      ],
      ['Principal in Charge', project.principalInCharge.name],
      ['Project Manager', project.projectManager.name]
    ]
    const hksInfo: string[][] = [
      ['Sector', project.practiceArea],
      ['Practice Area', project.practiceArea],
      ['Primary Country', project.primaryCountry],
      ['Primary Office', project.primaryOffice],
      ['Project Currency', project.projectCurrency],
      ['Billing Currency', project.billingCurrency]
    ]

    const projectDetails: string[][] = [
      ['Contract Type', project.contractType],
      ['Delivery Type', project.deliveryType],
      ['Services', project.services],
      ['Start Date', project.startDate],
      ['Completion Date', project.completionDate],
      ['Construction Costs (estimate)', project.estimatedConstructionCosts],
      ['Project Duration', '...'],
      ['Time Remaining', '...']
    ]
    return (
      <div className="fr w-75">
        <div className="project-page-heading">Project Details</div>
        <div className="flex flex-wrap">
          <InfoBox title="Basic Information" info={basicInfo} />
          <InfoBox title="HKS Information" info={hksInfo} />
          <InfoBox title="Project Details" info={projectDetails} />
        </div>
      </div>
    )
  }
}

export default ProjectDetail
